(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3109,9956],{

/***/ 83764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30730);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_badge_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53218);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69626);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93587);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67330);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__);







function Badge(param) {
    let { type , variant ="default" , size ="medium"  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    switch(type){
        case "bonus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bonus), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("bonus")
                    })
                ]
            });
        case "discount":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().discount), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 20
                })
            });
        case "popular":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popular), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("popular")
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
    }
}


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadMore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88700);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42041);



function LoadMore(param) {
    let { children , onClick , loading =false , size ="large"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loadMore), " ").concat(size === "small" ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().small) : (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().large)),
        disabled: loading,
        onClick: onClick,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 21
        }) : children
    });
}


/***/ }),

/***/ 791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42041);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88700);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 9956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Empty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55684);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_empty_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(791);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21867);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @next/next/no-img-element */ 




function Empty(param) {
    let { text , buttonText , link ="/"  } = param;
    const { push  } = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/delivery.webp",
                    alt: "Empty"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: text
                }),
                !!buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().actions),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: ()=>push(link),
                        children: buttonText
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 25627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79963);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86430);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 32737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42041);
/* harmony import */ var _loading_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36554);
/* harmony import */ var _loading_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_loading_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function Loading(param) {
    let {} = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_loading_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loading),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 41854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Price; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(46496);
// EXTERNAL MODULE: ./redux/slices/currency.ts
var slices_currency = __webpack_require__(23102);
;// CONCATENATED MODULE: ./utils/numberToPrice.ts
const numberToPrice = function(number) {
    let digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (number) {
        return number.toFixed(digits).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
    return "0";
};

;// CONCATENATED MODULE: ./components/price/price.tsx





function Price(param) {
    let { number =0 , minus , symbol , plus , digits , old  } = param;
    const currency = (0,useRedux/* useAppSelector */.C)(slices_currency/* selectCurrency */.j);
    const position = (currency === null || currency === void 0 ? void 0 : currency.position) || "before";
    const currencySymbol = symbol || (currency === null || currency === void 0 ? void 0 : currency.symbol) || "$";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat(minus ? "red" : "", " ").concat(old ? "strike" : ""),
        children: [
            minus ? "-" : "",
            plus ? "+" : "",
            position === "before" ? currencySymbol : "",
            numberToPrice(number, digits),
            position === "after" ? currencySymbol : ""
        ]
    });
}


/***/ }),

/***/ 16077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/productCard/productCard.module.scss
var productCard_module = __webpack_require__(55240);
var productCard_module_default = /*#__PURE__*/__webpack_require__.n(productCard_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(7592);
// EXTERNAL MODULE: ./components/price/price.tsx + 1 modules
var price = __webpack_require__(41854);
// EXTERNAL MODULE: ./components/badge/badge.tsx
var badge = __webpack_require__(83764);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(25627);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(54017);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/StarFillIcon.js
var StarFillIcon = __webpack_require__(42190);
var StarFillIcon_default = /*#__PURE__*/__webpack_require__.n(StarFillIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/StarLineIcon.js
var StarLineIcon = __webpack_require__(11675);
var StarLineIcon_default = /*#__PURE__*/__webpack_require__.n(StarLineIcon);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(77712);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(34131);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./containers/productCardCounterContainer/productCardCounterContainer.tsx



const ProductCardCounter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2560).then(__webpack_require__.bind(__webpack_require__, 82560)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(82560)
            ]
    }
});
const ProtectedProductCardCounter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7146).then(__webpack_require__.bind(__webpack_require__, 77146)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(77146)
            ]
    }
});
function ProductCardCounterContainer(param) {
    let { data  } = param;
    const { isAuthenticated  } = (0,auth_context/* useAuth */.a)();
    if (isAuthenticated) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtectedProductCardCounter, {
            data: data
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardCounter, {
        data: data
    });
}

// EXTERNAL MODULE: ./hooks/useLiked.tsx
var useLiked = __webpack_require__(99899);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/Heart3FillIcon.js
var Heart3FillIcon = __webpack_require__(49935);
var Heart3FillIcon_default = /*#__PURE__*/__webpack_require__.n(Heart3FillIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/Heart3LineIcon.js
var Heart3LineIcon = __webpack_require__(44900);
var Heart3LineIcon_default = /*#__PURE__*/__webpack_require__.n(Heart3LineIcon);
;// CONCATENATED MODULE: ./components/productCard/productCard.tsx















function ProductCard(param) {
    let { data  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const { isLiked , handleLikeOrDislike  } = (0,useLiked/* default */.Z)({
        type: "product",
        itemId: data === null || data === void 0 ? void 0 : data.id
    });
    const totalPrice = (data === null || data === void 0 ? void 0 : (ref = data.stock) === null || ref === void 0 ? void 0 : ref.total_price) || (data === null || data === void 0 ? void 0 : (ref1 = data.stocks) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.total_price) || 0;
    var ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "/product/".concat(data === null || data === void 0 ? void 0 : data.uuid),
        scroll: true,
        shallow: true,
        className: (productCard_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (productCard_module_default()).likeButton,
                onClick: (e)=>{
                    e.preventDefault();
                    handleLikeOrDislike();
                },
                children: isLiked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (productCard_module_default()).dislikeIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Heart3FillIcon_default()), {
                        size: 24
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (productCard_module_default()).likeIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Heart3LineIcon_default()), {
                        size: 24
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productCard_module_default()).addToCart,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardCounterContainer, {
                    data: data
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productCard_module_default()).badgeContainer,
                children: [
                    !!((data === null || data === void 0 ? void 0 : (ref3 = data.stock) === null || ref3 === void 0 ? void 0 : ref3.discount) || (data === null || data === void 0 ? void 0 : (ref4 = data.discounts) === null || ref4 === void 0 ? void 0 : ref4.length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).badge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                            type: "discount",
                            variant: "circle",
                            size: "medium"
                        })
                    }),
                    !!((data === null || data === void 0 ? void 0 : (ref5 = data.stock) === null || ref5 === void 0 ? void 0 : ref5.bonus) || (data === null || data === void 0 ? void 0 : (ref6 = data.stocks) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.bonus)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).badge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                            type: "bonus",
                            variant: "circle",
                            size: "medium"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productCard_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                    fill: true,
                    src: (0,getImage/* default */.Z)(data === null || data === void 0 ? void 0 : data.img),
                    alt: data === null || data === void 0 ? void 0 : (ref8 = data.translation) === null || ref8 === void 0 ? void 0 : ref8.title,
                    quality: 90,
                    sizes: "200px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productCard_module_default()).price,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price/* default */.Z, {
                    number: totalPrice
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (productCard_module_default()).title,
                children: data === null || data === void 0 ? void 0 : (ref9 = data.translation) === null || ref9 === void 0 ? void 0 : ref9.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (productCard_module_default()).review,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).rating,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                            value: (ref10 = data === null || data === void 0 ? void 0 : data.r_avg) !== null && ref10 !== void 0 ? ref10 : 0,
                            readOnly: true,
                            color: "var(--yellow-rating)",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((StarFillIcon_default()), {
                                size: 14
                            }),
                            emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((StarLineIcon_default()), {
                                size: 14
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (productCard_module_default()).reviewCount,
                        children: (ref11 = data === null || data === void 0 ? void 0 : data.r_count) !== null && ref11 !== void 0 ? ref11 : 0
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 13109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LikedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var containers_productList_productList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3649);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53218);
/* harmony import */ var _liked_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10047);
/* harmony import */ var _liked_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_liked_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_loader_loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32737);
/* harmony import */ var components_empty_empty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9956);
/* harmony import */ var components_button_load_more__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(763);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50959);








function LikedProducts(param) {
    let { data , isLoading =false , hasNextPage =false , isFetchingNextPage =false , fetchingNextPage  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const renderView = ()=>{
        if (!(data === null || data === void 0 ? void 0 : data.length)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_empty_empty__WEBPACK_IMPORTED_MODULE_4__["default"], {
                text: t("no.liked.products")
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_productList_productList__WEBPACK_IMPORTED_MODULE_1__["default"], {
            products: data
        });
    };
    const handleLoadNexPage = ()=>{
        if (hasNextPage && fetchingNextPage) {
            fetchingNextPage();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: (_liked_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                children: t("liked.products")
            }),
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_loader_loading__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
            renderView(),
            hasNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_button_load_more__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                loading: isFetchingNextPage,
                onClick: handleLoadNexPage,
                children: t("load.more")
            })
        ]
    });
}


/***/ }),

/***/ 3649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductList; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(52709);
// EXTERNAL MODULE: ./components/productCard/productCard.tsx + 1 modules
var productCard = __webpack_require__(16077);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowRightSLineIcon.js
var ArrowRightSLineIcon = __webpack_require__(19457);
var ArrowRightSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightSLineIcon);
// EXTERNAL MODULE: ./components/listHeader/listHeader.module.scss
var listHeader_module = __webpack_require__(45496);
var listHeader_module_default = /*#__PURE__*/__webpack_require__.n(listHeader_module);
;// CONCATENATED MODULE: ./components/listHeader/listHeader.tsx





function ListHeader(param) {
    let { title , href  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (listHeader_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (listHeader_module_default()).title,
                children: title
            }),
            href && (href === null || href === void 0 ? void 0 : href.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                href: href,
                className: (listHeader_module_default()).link,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("see.all")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightSLineIcon_default()), {
                        size: 24
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./containers/productList/productList.module.scss
var productList_module = __webpack_require__(25349);
var productList_module_default = /*#__PURE__*/__webpack_require__.n(productList_module);
;// CONCATENATED MODULE: ./containers/productList/productList.tsx





function ProductList(param) {
    let { title , products , loading =false , uuid ="popular"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        "data-section": true,
        id: uuid,
        style: {
            display: !loading && products.length === 0 ? "none" : "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (productList_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (productList_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListHeader, {
                        title: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (productList_module_default()).list,
                    children: !loading ? products.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(productCard/* default */.Z, {
                            data: item
                        }, item.id)) : Array.from(new Array(4)).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            className: (productList_module_default()).shimmer
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 99899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLiked; }
/* harmony export */ });
/* harmony import */ var _useRedux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46496);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var redux_slices_liked__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99719);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77712);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49532);
/* harmony import */ var services_like__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61960);
/* harmony import */ var components_alert_toast__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25373);







function useLiked(param) {
    let { type , itemId  } = param;
    const dispatch = (0,_useRedux__WEBPACK_IMPORTED_MODULE_0__/* .useAppDispatch */ .T)();
    const queryClint = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useQueryClient)();
    const { isAuthenticated  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    const { shopList , productList  } = (0,_useRedux__WEBPACK_IMPORTED_MODULE_0__/* .useAppSelector */ .C)((state)=>state.liked);
    const isLiked = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        switch(type){
            case "shop":
                return !!shopList.length && shopList.some((item)=>item.shopId === itemId);
            case "product":
                return !!productList.length && productList.some((item)=>item.productId === itemId);
            default:
                return false;
        }
    }, [
        type,
        itemId,
        shopList,
        productList
    ]);
    const { mutate: likeRequest  } = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useMutation)({
        mutationFn: (body)=>services_like__WEBPACK_IMPORTED_MODULE_5__/* ["default"].like */ .Z.like(body),
        onError: (err)=>{
            (0,components_alert_toast__WEBPACK_IMPORTED_MODULE_6__/* .error */ .vU)(err === null || err === void 0 ? void 0 : err.message);
        }
    });
    const { mutate: dislikeRequest  } = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useMutation)({
        mutationFn: (body)=>services_like__WEBPACK_IMPORTED_MODULE_5__/* ["default"].disLike */ .Z.disLike(body),
        onMutate: async (body)=>{
            if (body.type === "product") {
                await queryClint.cancelQueries([
                    "likedProducts"
                ], {
                    exact: false
                });
                const prevLikeList = queryClint.getQueryData([
                    "likedProducts"
                ], {
                    exact: false
                });
                queryClint.setQueriesData({
                    queryKey: [
                        "likedProducts"
                    ],
                    exact: false
                }, (old)=>{
                    var ref;
                    if (!old) return prevLikeList;
                    return {
                        ...old,
                        pages: old === null || old === void 0 ? void 0 : (ref = old.pages) === null || ref === void 0 ? void 0 : ref.map((page)=>{
                            var ref;
                            return {
                                ...page,
                                data: page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.filter((product)=>{
                                    return (product === null || product === void 0 ? void 0 : product.id) !== body.type_id;
                                })
                            };
                        })
                    };
                });
                return {
                    prevLikeList
                };
            }
        },
        onError: (err)=>{
            (0,components_alert_toast__WEBPACK_IMPORTED_MODULE_6__/* .error */ .vU)(err === null || err === void 0 ? void 0 : err.message);
        }
    });
    const handleLocalLikeOrDislike = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        dispatch((0,redux_slices_liked__WEBPACK_IMPORTED_MODULE_2__/* .likeOrDislike */ .jN)({
            type,
            ["".concat(type, "Id")]: itemId,
            sent: isAuthenticated
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        type,
        itemId,
        isAuthenticated
    ]);
    const handleLikeOrDislike = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (isAuthenticated) {
            if (isLiked) {
                dislikeRequest({
                    type,
                    type_id: itemId
                });
            } else {
                likeRequest({
                    type,
                    type_id: itemId
                });
            }
        }
        handleLocalLikeOrDislike();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        type,
        itemId,
        isAuthenticated,
        isLiked
    ]);
    return {
        isLiked,
        handleLikeOrDislike
    };
}


/***/ }),

/***/ 7592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ }),

/***/ 30730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__BHeKC","default":"badge_default__18BvY","circle":"badge_circle__mQVZ_","text":"badge_text__cdsyf","large":"badge_large__bhCOW","medium":"badge_medium__3BTPx","bonus":"badge_bonus__Ice67","discount":"badge_discount__gVAeQ","popular":"badge_popular__ywwJB"};

/***/ }),

/***/ 55684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"empty_wrapper__nwTin","text":"empty_text__oRHIv","actions":"empty_actions__NNcWA"};

/***/ }),

/***/ 79963:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 45496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"listHeader_container__Tuxzy","title":"listHeader_title__ORWhf","link":"listHeader_link__1KnGl"};

/***/ }),

/***/ 36554:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__hXLim","pageLoading":"loading_pageLoading__0nn5j"};

/***/ }),

/***/ 55240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"productCard_wrapper__ztIcZ","likeButton":"productCard_likeButton__r2ZAt","dislikeIcon":"productCard_dislikeIcon__2geyM","likeIcon":"productCard_likeIcon__aY3LH","addToCart":"productCard_addToCart__TD_N_","badgeContainer":"productCard_badgeContainer__0GSMs","badge":"productCard_badge__N7EGr","imageContainer":"productCard_imageContainer__6uEuG","price":"productCard_price__t9Hq0","title":"productCard_title__0ht20","review":"productCard_review__yoZ_X","rating":"productCard_rating__gdU_4","reviewCount":"productCard_reviewCount__gunhv"};

/***/ }),

/***/ 25349:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"productList_container__HhhDR","header":"productList_header__tWYya","title":"productList_title__gO1y3","list":"productList_list__g7rpn","shimmer":"productList_shimmer__oB__l"};

/***/ }),

/***/ 49935:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Heart3FillIcon = function Heart3FillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2z' })
  );
};

var Heart3FillIcon$1 = React__default['default'].memo ? React__default['default'].memo(Heart3FillIcon) : Heart3FillIcon;

module.exports = Heart3FillIcon$1;


/***/ }),

/***/ 42190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var StarFillIcon = function StarFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 18.26l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928z' })
  );
};

var StarFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(StarFillIcon) : StarFillIcon;

module.exports = StarFillIcon$1;


/***/ }),

/***/ 11675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var StarLineIcon = function StarLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 18.26l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26zm0-2.292l4.247 2.377-.949-4.773 3.573-3.305-4.833-.573L12 5.275l-2.038 4.42-4.833.572 3.573 3.305-.949 4.773L12 15.968z' })
  );
};

var StarLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(StarLineIcon) : StarLineIcon;

module.exports = StarLineIcon$1;


/***/ })

}]);